import debounce from 'lodash.debounce';

export default {

    inserted: function (el, binding) {

        const targetSelector = typeof binding.value === 'string'
            ? binding.value
            : binding.value.target;
        const breakpoint = binding.value.breakpoint;

        let intrinsicPosition = document.querySelector(targetSelector + '-intrinsic');

        const placeholder = () => {
            var template = document.createElement('template');
            template.innerHTML = `<div class="move-placeholder" id="${targetSelector.substring(1)}-intrinsic"></div>`;

            return template.content.firstChild;
        }

        function move() {
            el.appendAfter(window.isViewport(breakpoint)
                ? targetSelector
                : intrinsicPosition);
        }

        if (!intrinsicPosition) {
            (placeholder()).appendBefore(el);
            intrinsicPosition = document.querySelector(targetSelector + '-intrinsic');
        }

        if (typeof binding.value === 'string') {
            el.appendAfter(targetSelector);
        } else {
            move();
            window.addEventListener('resize', debounce(() => { move() }), 750);
        }

	}

}
